import { lazy, Suspense, useState } from 'react'

import { ErrorBoundary } from '@/components/common/error-boundary'
import { TableSkeleton } from '@/components/skeletons/table-skeleton'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

import { useNotifications } from '../queries'
import NotificationMenu from './menu'

const NotificationList = lazy(() => import('./list'))

const NotificationPanel = () => {
	const {
		data: { notifications },
	} = useNotifications({
		is_read: false,
		exclude_channel: 'global',
	})

	const [tab, setTab] = useState<'unread' | 'read'>('unread')

	return (
		<div className="flex flex-col items-start justify-start gap-2 pr-3">
			<Tabs
				value={tab}
				className="w-full"
				onValueChange={(value) => setTab(value as 'unread' | 'read')}
			>
				<div className="flex flex-row items-center justify-start gap-2">
					<TabsList>
						<TabsTrigger value="unread" autoFocus>
							Unread {notifications.length > 0 && `(${notifications.length})`}
						</TabsTrigger>
						<TabsTrigger value="read">Read</TabsTrigger>
					</TabsList>

					<div className="flex-auto" />

					<ErrorBoundary fallback={() => <></>}>
						<Suspense fallback={null}>
							{tab === 'unread' && <NotificationMenu />}
						</Suspense>
					</ErrorBoundary>
				</div>

				<TabsContent value="unread">
					<ErrorBoundary>
						<Suspense fallback={<TableSkeleton rows={4} />}>
							<NotificationList read={false} />
						</Suspense>
					</ErrorBoundary>
				</TabsContent>

				<TabsContent value="read">
					<ErrorBoundary>
						<Suspense fallback={<TableSkeleton rows={4} />}>
							<NotificationList read={true} />
						</Suspense>
					</ErrorBoundary>
				</TabsContent>
			</Tabs>
		</div>
	)
}

export default NotificationPanel
